/**
 * Veeroute.Delivery
 * Veeroute Delivery API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Capacity characteristics.
 */
export interface CapacityDelivery { 
    /**
     * Weight in kilograms.
     */
    mass?: number;
    /**
     * Volume in cubic meters.
     */
    volume?: number;
    /**
     * Additional capacity parameter (X) for measuring cargoes and compartments in alternative units. For example, to account for cargo in pieces (this parameter is equal to one for a cargo and the maximum number of cargo to hold for a compartment). 
     */
    capacity_x?: number;
    /**
     * Additional capacity parameter (Y) for measuring cargoes and compartments in alternative units.
     */
    capacity_y?: number;
    /**
     * Additional capacity parameter (Z) for measuring cargoes and compartments in alternative units.
     */
    capacity_z?: number;
}

